<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { appendEditor, dispatchEditorEvents } from 'pintura';

export default {
  inheritAttrs: false,

  mounted() {
    // create editor
    this.editor = appendEditor(this.$refs.elementRef, this.$attrs);

    // listen for editor events and propagate to component
    this.unsubs = dispatchEditorEvents(this.editor, (type, value) => {
      this.$emit(`pintura:${type}`, value);
    });

    // observe prop changes
    this.unwatch = this.$watch('$attrs', () => {
      const attrs = this.$attrs;
      Object.assign(this.editor, attrs);
    });
    [
      { title: 'Zoom out', id: 'zoom-out' },
      { title: 'Zoom in', id: 'zoom-in' },
      { title: 'History back', id: 'undo' },
      { title: 'History forward', id: 'redo' },
      { title: 'Selection tool for text and images', id: 'move-logo' },
      { title: 'Click to pan around the print position', id: 'move-image' },
    ].forEach((el) => this.observeDOMChanges(el.title, el.id));
  },
  beforeDestroy() {
    if (!this.editor) return;
    this.editor.destroy();
    this.unsubs.forEach((unsub) => unsub());
    this.unsubs = [];
    this.unwatch();
    this.editor = undefined;
  },
  methods: {
    observeDOMChanges(title, id) {
      const observer = new MutationObserver(() => {
        const element = this.$el.querySelector(`[title="${title}"]`);
        if (element) {
          element.id = id;
          observer.disconnect(); // Stop observing once the element is found and updated
        }
      });
      observer.observe(this.$el, {
        childList: true,
        subtree: true,
      });
    },
  },

  render(h) {
    return h('div', {
      attrs: { class: 'PinturaRootWrapper' },
      ref: 'elementRef',
    });
  },
};
</script>
